import TextColumn from './TextColumn.js';

export default TextColumn;
